import { render } from "./consuleOne.vue?vue&type=template&id=2954454b&scoped=true"
import script from "./consuleOne.vue?vue&type=script&lang=js"
export * from "./consuleOne.vue?vue&type=script&lang=js"

import "./consuleOne.vue?vue&type=style&index=0&id=2954454b&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2954454b"]])

export default __exports__